// @flow
import { connect } from 'react-redux';
import { withProps, compose } from 'react-recompose';
import RoamingFrames from './RoamingFrames';
import { roamingPackageUsagesSelector } from '../../../../modules/Usage/selectors';
import type { StateType } from '../../../../modules/reducers';
import type { StateProps } from './RoamingFrames';

const withRoamLikeHomeProps = () => ({
  type: 'ROAM_LIKE_HOME',
});

const mapStateToProps = (state: StateType): StateProps => ({
  packages: roamingPackageUsagesSelector(state),
});

export default compose(connect(mapStateToProps), withProps(withRoamLikeHomeProps))(RoamingFrames);
